import React, { useState } from "react";
import userIcon from "../../assets/images/user.svg";
import contactEditIcon from "../../assets/images/contact-edit-icon.svg";
import contactDeleteIcon from "../../assets/images/contact-delete-icon.svg";
import contactNotificationIcon from "../../assets/images/contact-notification-icon.svg";
import contactMessageIcon from "../../assets/images/contact-message-icon.svg";
import NewMessageModal from "../Messages/NewMessageModal";
import { encodePhoneNumber } from "../../helpers/Utils";
import { fetchMoreContacts } from "../../redux/action";
import { useDispatch, useSelector } from "react-redux";
import { Box } from "@chakra-ui/react";
export default function ({
  contacts,
  handleSelectedContact,
  handleScroll,
  query,
}) {
  const dispatch = useDispatch();
  //const contacts=useSelector((state)=>state.contacts);

  const [isVisible, setIsVisible] = useState(false);
  const [num, setNum] = useState({});

  const handleMessageModal = () => {
    setIsVisible((old) => !old);
  };

  const userSelectedFont = useSelector((state) => state.settings.fontsize);

  return (
    <>
      <table
        style={{
          fontSize:
            userSelectedFont === "small"
              ? "14px"
              : userSelectedFont === "medium"
              ? "16px"
              : userSelectedFont === "large"
              ? "20px"
              : "20px",
        }}
        className="mt-2 table table-borderless">
        <thead>
          <tr>
            {/*   <th className="align-middle" style={{width:'12%'}} scope="col">ID</th> */}
            <th className="align-middle" style={{ width: "10%" }} scope="col">
              First Name
            </th>
            <th className="align-middle" style={{ width: "10%" }} scope="col">
              Last Name
            </th>
            <th className="align-middle" style={{ width: "16%" }} scope="col">
              Phone Number
            </th>
            <th className="align-middle" style={{ width: "18%" }} scope="col">
              Tags
            </th>
            {/*  <th className="align-middle" style={{width:'16%'}} scope="col">Address</th>*/}
            <th className="align-middle" style={{ width: "18%" }} scope="col">
              Actions
            </th>
          </tr>
        </thead>
        <tbody>
          {contacts.data.map((contact) => (
            <tr key={contact.id}>
              {/*<td className="align-middle">
             <img width="32" height="32" className="img-fluid me-1" src={userIcon}/> {contact.id}</td>*/}
              <td className="align-middle">{contact.first_name}</td>
              <td className="align-middle">{contact.last_name}</td>
              <td className="align-middle">
                {encodePhoneNumber(contact.phone_no)}
              </td>
              <td className="align-middle">
                {contact.tags.map((tag) => (
                  <div key={tag.id} className="tag me-1">
                    {tag.tag}
                  </div>
                ))}
              </td>
              {/* <td className="align-middle">{contact.address}</td>*/}
              <td className="align-middle">
                <button
                  className="slider-close-btn me-1"
                  type="button"
                  data-bs-toggle="offcanvas"
                  data-bs-target="#editContactCanvas"
                  onClick={() => handleSelectedContact(contact)}
                  aria-controls="editContactCanvas">
                  <img src={contactEditIcon} className="img-fluid" />
                </button>
                <button
                  className="slider-close-btn me-1"
                  data-bs-toggle="modal"
                  data-bs-target="#delteContact"
                  onClick={() => handleSelectedContact(contact)}>
                  <img src={contactDeleteIcon} className="img-fluid" />
                </button>
                <button
                  className="slider-close-btn me-1"
                  data-bs-toggle="offcanvas"
                  data-bs-target="#reminderContactCanvas"
                  aria-controls="reminderContactCanvas"
                  onClick={() => handleSelectedContact(contact)}>
                  <img src={contactNotificationIcon} className="img-fluid" />
                </button>
                <button
                  className="slider-close-btn me-1"
                  onClick={() => {
                    setNum({
                      value: contact.phone_no,
                      label: contact.full_name,
                    });
                    handleMessageModal();
                  }}>
                  <img src={contactMessageIcon} className="img-fluid" />
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      {contacts.isLoading && <div className="loading" />}
      <NewMessageModal
        isVisible={isVisible}
        toggle={handleMessageModal}
        number={num}
      />
    </>
  );
}
